const FireproofingTypesElPaso = () => {
  const fireproofingTypes = [
    {
      image: 'https://public.readdy.ai/ai/img_res/1c0c8e925e18ee1e21119579625f8b6b.jpg',
      title: 'Spray-Applied Fireproofing',
      description: 'Cementitious or fiber-based spray fireproofing providing cost-effective fire protection for structural steel.',
      features: ['UL Listed Systems', '1-4 Hour Ratings', 'Cost-Effective', 'Quick Application']
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Intumescent%20paint%20coating%20on%20steel%20column%20with%20smooth%20white%20finish%2C%20thin-film%20fire%20protection%20system%2C%20modern%20commercial%20interior%2C%20simple%20background%20highlighting%20advanced%20intumescent%20coating%20technology%20and%20aesthetic%20fire%20protection&width=800&height=600&seq=fireproofing-type-intumescent-001&orientation=landscape',
      title: 'Intumescent Coatings',
      description: 'Thin-film intumescent paint that expands when heated, creating an insulating char layer for fire protection.',
      features: ['Aesthetic Finish', 'Exposed Applications', 'Multiple Colors', 'Minimal Thickness']
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Fire-rated%20gypsum%20board%20wall%20assembly%20installation%20in%20commercial%20building%2C%20layered%20drywall%20construction%20with%20metal%20studs%2C%20simple%20background%20showcasing%20fire-resistant%20wall%20system%20and%20code-compliant%20construction%20methods&width=800&height=600&seq=fireproofing-type-gypsum-001&orientation=landscape',
      title: 'Fire-Rated Gypsum Board',
      description: 'Type X gypsum board assemblies providing fire resistance for walls, ceilings, and shaft enclosures.',
      features: ['1-4 Hour Ratings', 'Sound Attenuation', 'Easy Installation', 'Code Compliant']
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Firestop%20sealant%20being%20applied%20around%20pipe%20penetration%20through%20concrete%20floor%2C%20red%20fire-rated%20caulking%20material%2C%20commercial%20building%20construction%2C%20simple%20background%20showcasing%20firestopping%20installation%20and%20penetration%20sealing%20expertise&width=800&height=600&seq=fireproofing-type-firestop-001&orientation=landscape',
      title: 'Firestop Systems',
      description: 'Firestopping materials sealing penetrations and joints to prevent fire and smoke spread.',
      features: ['UL Certified', 'Penetration Sealing', 'Joint Systems', 'Smoke Barriers']
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Concrete%20encasement%20around%20steel%20column%20in%20commercial%20building%2C%20thick%20protective%20concrete%20covering%20structural%20steel%2C%20industrial%20construction%20setting%2C%20simple%20background%20highlighting%20concrete%20fire%20protection%20and%20structural%20fireproofing%20methods&width=800&height=600&seq=fireproofing-type-concrete-001&orientation=landscape',
      title: 'Concrete Encasement',
      description: 'Concrete or masonry encasement providing maximum fire protection for structural steel members.',
      features: ['Maximum Protection', 'High Durability', '3-4 Hour Ratings', 'Impact Resistant']
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Fire-rated%20mineral%20wool%20insulation%20board%20installation%20on%20steel%20beam%2C%20dense%20fibrous%20insulation%20material%2C%20commercial%20construction%20application%2C%20simple%20background%20showcasing%20mineral%20fiber%20fire%20protection%20and%20thermal%20insulation%20properties&width=800&height=600&seq=fireproofing-type-mineral-001&orientation=landscape',
      title: 'Mineral Fiber Boards',
      description: 'Rigid mineral fiber boards providing fire protection with excellent thermal and acoustic properties.',
      features: ['Thermal Insulation', 'Sound Dampening', 'Non-Combustible', 'Easy to Install']
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Fireproofing Solutions for El Paso Buildings
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Choose from a variety of fireproofing systems designed to meet building code requirements and provide optimal fire protection for commercial and industrial structures in El Paso.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {fireproofingTypes.map((type, index) => (
            <div
              key={index}
              className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow"
            >
              <div className="w-full h-64">
                <img
                  src={type.image}
                  alt={type.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {type.title}
                </h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {type.description}
                </p>
                <ul className="space-y-2">
                  {type.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-sm text-gray-700">
                      <i className="ri-check-line text-red-600 mr-2"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FireproofingTypesElPaso;
